

import $ from 'jquery';
import React from 'react';
import PreLoginPage from '../../../views/core/PreLoginPage';
import FlipBox from './FlipBox';
import SampleLessonLayout from './SampleLessonLayout';
import Swiper from 'react-id-swiper';
import { func } from 'prop-types';
import Slider from "react-slick";
import HmAjax from '../../../util/HmAjax';

import TestTakingModalComponent from '../../../views/plp/TestTakingModalComponent';
import BillingForm from '../../../views/purchase/TchrBillingForm';
import NativeAjax from '../../../util/NativeAjax';
import BrowserStorageUtil from '../../../util/BrowserStorageUtil';
import CouponCodeModel from '../../../views/purchase/CouponCodeModel';
import CouponCodeLayout from '../../../views/purchase/CouponCodeLayout';


var settings = {
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
    {
        breakpoint: 1370,
        settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
            infinite: false,
            dots: false
        }
    },
    {
        breakpoint: 1100,
        settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: false,
            dots: false
        }
    },
    {
        breakpoint: 767,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 3
        }
    },
    {
        breakpoint: 550,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
    }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
            ]
        };


class TeacherProdComp  extends PreLoginPage {

    constructor(props){
        super(props)
        this.state={
            tchrdata:{},
            chooseGrade:null,
            products_details: {},
            OPSAvailable:false,
            ModalShow:false,
            review_order:false,
            BillingFormShow:false,
            currentGradeIndex:0,
            dataLoaded: false,
            teacherLessonsList:null,
            selectedGrade:'',
            purchaseObj:null,
            noData: false,
            couponApplied:false,
            SubscribeModal:false,
            trackId:0,
            couponCodeTracked:false
        };
        this.swiper = null;
        this.productCateBox = this.productCateBox.bind(this);
        this.renderClassTab=this.renderClassTab.bind(this);
        this.similarLessonList = {};


        this.productsJson = {};
        //this.purchaseObj = null;
        this.appDetails =  {};
        this.tchrgradeOrder=[];
        
        this.productEvt = null;

        this.teacherLumosProduct = null;

        this.showBillingForm = this.showBillingForm.bind(this);
        this.renderbillingForm = this.renderbillingForm.bind(this);
        this.showOrderReview = this.showOrderReview.bind(this);
        this.hideBillingModal=this.hideBillingModal.bind(this);
        this.hideReviewModal = this.hideReviewModal.bind(this);
        this.teachergradeSwiper = this.teachergradeSwiper.bind(this);
        this.couponValidFn = this.couponValidFn.bind(this);
        this.setTrackId = this.setTrackId.bind(this);
        this.SuccesscallBackFn = this.SuccesscallBackFn.bind(this);
        this.hideSubscribeModal =  this.hideSubscribeModal.bind(this);
    }

    couponValidFn(response){
        if(response && typeof response=="object"){
            this.SuccesscallBackFn(response);
            this.setState({couponApplied:true})
        }
    }

    setTrackId(trackId,couponCodeTracked){
     this.setState({trackId:trackId,couponCodeTracked:couponCodeTracked})
    }

    componentWillMount(){		
		var me =this;
		  var callBackSuccess = function(response){
			if(response !== null){
				if (response.status === 'active') {
					me.setState({OPSAvailable:true});
				}
			}
	
			//console.log("OPS_DETECT response : ", response);
		}
	
		var callBackFailure = function(response){			
			console.log("Error in OPS_DETECT");		
		}
	
        new HmAjax(this.getUrlFor("OPS_DETECT")).get(callBackSuccess,callBackFailure);
        
        // try {
		// 	this.userObj = JSON.parse(BrowserStorageUtil.getStoredItem(this.userDataKey));
		// 	//console.log("userobj::",this.userObj);
		// 	for(var key in this.userObj){
		// 		this.userId = this.userObj[key].USER_DETAILS.userId;
		// 		this.userCountryCode = this.userObj[key].USER_DETAILS.countryCode;
		// 	}
			
		// } catch (e) {}
    }
    
    componentDidMount() {
		var me = this;

		try{
            var refUrl = document.referrer;

            let centaRef = me.callByReferer(refUrl)
            let userLoggedIn = (this.getUser().getUserId() && this.getUser().getUserId().length > 0) ? true : false;
            let userOrigin  = this.getUser().getUserOrigin();
            let couponcodeCenta = this.getAttribute("couponcodeCenta") || '';

            let AllowUserOrigin = me.callByOrigin(userOrigin)

            if((centaRef && !userLoggedIn) || (AllowUserOrigin && userLoggedIn && (couponcodeCenta==="")))
            {
                me.setState({SubscribeModal:true});
            }
            else if(AllowUserOrigin && (couponcodeCenta==="")){
                me.setState({SubscribeModal:true});
            }
            
            me.tchrgetProductDetails();
        }catch(e){
            console.error("Error occurred while couponcode", e);
        }		
    }
    
    SuccesscallBackFn(response){
        var me = this;
        if(response!==null){
            me.productsJson = response;
            var sortedProducts = me.sortTeacherProducts(response);
            me.teacherLumosProduct = sortedProducts[0]; 
            
            if(response.categories && response.categories.TCHR_SPL){
                let tchrdata = Object.values(response.categories.TCHR_SPL.grade_wise);

                if(tchrdata && tchrdata.length>0){
                    me.tchrgradeOrder = [];                        

                    tchrdata.map((gradeList,index) => {
                        me.tchrgradeOrder.push(gradeList.gradeDisplayName);
                    }                        
                    );
                     
                    let teacherLessonsList = null;
                    let gradeName = (tchrdata[0].gradeDisplayName).toLowerCase().replace(/\s/g,'') || '';
                    let TeacherLessonMaps = window.TeacherLessonMaps || {};
                    teacherLessonsList = TeacherLessonMaps[gradeName];


                    me.setState({teacherLessonsList:teacherLessonsList,chooseGrade:tchrdata[0].gradeDisplayName,tchrdata:tchrdata,dataLoaded:true,currentGradeIndex:0,selectedGrade:gradeName}); //chooseGrade:tchrdata[0].gradeDisplayName,
                    
                 }else{
                    me.setState({noData:true});
                 }
            }else{
                me.setState({noData:true});
            }
        }
    }

	tchrgetProductDetails(){
		var me = this;
		var callBackSuccess = function(response){
			me.SuccesscallBackFn(response)
		}

		var callBackFailure = function(response){	
             me.setState({noData:true});	
			console.log("Error in PRODUCT_DETAILS");		
		}
		new NativeAjax(this.getUrlFor("TCHR_PRODUCTS")).enableCORS().post(callBackSuccess,callBackFailure);
    }

    sortTeacherProducts(data){
		var products = (data && data.productList && data.productList.length > 0) ? data.productList : [];
		var tchrProducts = [];
		var filterProductCategories = window.teacherProdProducts || [];

		var appName = data.appName;
		var appId = data._appId;
        
        this.appDetails.appName = appName;
        this.appDetails.appId = appId;

		if(products.length > 0){
			for(let i=0;i<products.length;i++){
			if(filterProductCategories && filterProductCategories.length > 0 && filterProductCategories.indexOf(products[i].productCategory) > -1){
				products[i]["appName"] = appName;
				products[i]["appId"] = appId;
				tchrProducts.push(products[i]);
			}else if((!filterProductCategories || filterProductCategories.length == 0) && !isNaN(products[i].productCategory)){
				products[i]["appName"] = appName;
				products[i]["appId"] = appId;
				tchrProducts.push(products[i]);
			}
		}
        }
        //console.warn("tchr prod",tchrProducts);
		return tchrProducts;
     }

      showBillingForm(productObj){
        let me = this;
        let userLoggedIn = (this.getUser().getUserId() && this.getUser().getUserId().length > 0) ? true : false;

        //React.unmountComponentAtNode(document.getElementById('tchrbilling'));

        if(productObj && productObj.productId){
            if(this.state.purchaseObj && this.state.purchaseObj.productId){
                //Product already exists
                if(this.state.purchaseObj.productId !== productObj.productId){
                    this.setState({purchaseObj:null,BillingFormShow:false,ModalShow:false});
                }
            }
        }else{
            return;
        }

        let tempFunc = () => {
            if(typeof me.props.postLoginCallBack === "function"){
                me.props.postLoginCallBack();
            }

            userLoggedIn = (me.getUser().getUserId() && me.getUser().getUserId().length > 0) ? true : false;

            if(productObj && productObj.productId){
                me.purchaseObj = productObj;
                me.setState({purchaseObj:productObj,BillingFormShow:true,ModalShow:true});
            } 
        }

        if(!userLoggedIn){
            if(typeof this.props.showSubscriptionForm === "function"){
                console.warn("productObj ",productObj);
                var gradeName = (productObj.gradeName).toLowerCase().replace(/\s/g,'') || '';
                var productName = (productObj.productName).toLowerCase().replace(/\s/g,'') || '';
                this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":gradeName+"-"+productName+"-subscribebtn"});
                this.props.showSubscriptionForm(tempFunc);
            }
        }else{
            tempFunc();
        }        
    }

	hideBillingModal(){ // Shyam
        /*
        * IMPORTANT: It is very IMPORTANT to unmount the Billing form.
        */
		this.setState({ModalShow:false});
	}

	showOrderReview(){
		this.setState({review_order:true});
	}

	hideReviewModal(){
        this.setState({review_order:false});
    }

    hideSubscribeModal(){
        this.setState({SubscribeModal:false});
    }

    renderCouponCodeModel(){
        if(!this.state.couponApplied){
            let couponCode = this.getAttribute("couponcodeCenta") || '';
            return (
                <CouponCodeModel {...this.props} couponCode={couponCode} setTrackId={this.setTrackId} couponApplied={this.state.couponApplied} hideSubscribeModal={this.hideSubscribeModal} showSubscriptionForm={this.props.showSubscriptionForm} callBackParent={this.couponValidFn} SubscribeModal={this.state.SubscribeModal} couponCodeTracked={this.state.couponCodeTracked}/>
            )
        }
    }

    callByReferer(url){
        var couponTrackers = window.couponTrackers || {}
        if(url && couponTrackers){
            for(var i in couponTrackers){
                if(url.match(i)){
                    return true;
                }
            }
        }
        return false;
    }

    callByOrigin(origin){
        var couponPopup = window.couponPopup || []
        if(origin && origin.length > 1 && couponPopup && couponPopup.length > 0){
            return (~couponPopup.indexOf(origin)) ? true : false;
        }
        return false;
    }
    
    renderbillingForm(){
        //console.log("renderbilling Form ",this.state.ModalShow);
        return (
                <div>
                    <TestTakingModalComponent visible={this.state.ModalShow} dialogClassName="modal-md">
                    <div className="loginHeader text-center">	
                    <div className="text-center modallogo loginHeaderTxt">
                    {this.rb("billing.information")}
                    </div>
                    <div className="close loginClose" onClick={this.hideBillingModal}  aria-label="Close">
                    <span aria-hidden="true"><i className="material-icons">close</i></span>
                    </div>
                    </div>
                    <div className="modal-body">
                    {
                        (()=>{
                            if(this.state.purchaseObj && this.state.ModalShow){
                                return (
                                    
                                    <BillingForm trackId={this.state.trackId} purchaseObj={this.state.purchaseObj} productsJson={this.productsJson} myProps={this.props}  ModalShow={this.state.ModalShow} showBillingForm={this.showBillingForm} hideBillingModal={this.hideBillingModal} review_order={this.state.review_order} showOrderReview={this.showOrderReview} hideReviewModal={this.hideReviewModal} purchaseKey={this.state.purchaseKey} />
                                    
                                )
                            }else if(!this.state.ModalShow){
                                return null;
                            }
                        })()
                    }
                    </div>							
                    </TestTakingModalComponent>
                </div>
        )
    }

 

    renderClassTab(list,indVal){
        if(this.state.chooseGrade == list){
            return (
                <div className="swiper-slide" key={indVal} >
           <div >
           <div className="swiper-active" data-grade={list} data-index={indVal} onClick={this.gradeTabClickFn.bind(this)}>
        {list}
               </div>
               </div>
            </div>
            )
        }else{
            return (
                <div className="swiper-slide" key={indVal} >
           <div>
           <div className="grade" data-grade={list} data-index={indVal} onClick={this.gradeTabClickFn.bind(this)}>
           {list}
               </div>
               </div>
            </div>
            )
        }
    }

    teachergradeSwiper(){                 
         var me=this;
         if(me.state.tchrdata && me.state.tchrdata!=null && me.tchrgradeOrder.length>0){
            return(
                <div className="row tchrswiper">   
                        <div className="swiper-container row allMiddle">
                            <div className="col-sm-12 col-xs-12 col-md-12 col-lg-12 imgGal">
                                <div className="col-12 text-center scorecardLessons">

                                <Slider {...settings}>
                                    {
                                         me.tchrgradeOrder.map((list, index) =>                
                                         this.renderClassTab(list,index)
                                         )
                                        
                                        }
                                     </Slider>
                                </div>
                            </div>
                        </div>
                    </div> 	
            )
         }
    }

    gradeTabClickFn(e){
        //console.warn("grade ",e.target.dataset.index);
        let allElements = Array.from(document.querySelectorAll('.swiper-active'));
        for (let element of allElements) {
          if($(element).hasClass('swiper-active')){
            element.classList.remove('swiper-active')
            element.classList.add('grade')
          }
        }
       if($(e.target).hasClass('grade')){
            $(e.target).removeClass('grade')
            $(e.target).addClass("swiper-active");
        }

        let teacherLessonsList = null;
        let gradeName = (this.state.tchrdata[e.target.dataset.index].gradeDisplayName).toLowerCase().replace(/\s/g,'') || '';
        let TeacherLessonMaps = window.TeacherLessonMaps || {};
        teacherLessonsList = TeacherLessonMaps[gradeName];

          $(".tchrprodanim").animate({
            opacity: 0
          },"fast",function(){
                $(".tchrprodanim").animate({
                        opacity: 1
                    });   
          });
          

        this.setState({teacherLessonsList:teacherLessonsList,selectedGrade:gradeName,currentGradeIndex:e.target.dataset.index,chooseGrade:e.target.dataset.grade});
    }

    productCateBox(){
        var me = this;
        let gradeData = null;

        if(me.state.tchrdata && me.state.tchrdata!=null && me.tchrgradeOrder.length>0 && me.state.teacherLessonsList){
            gradeData= me.state.tchrdata[me.state.currentGradeIndex].tariffDetails;
        
            return(
                <div className="flex-container">
                {
                    (()=>{
                        return (Object.values(gradeData).map((gradeBox,index) => 
                        {
                            let productDetails = gradeBox.productDetails;
                        return (
                            <FlipBox key={index} OPSAvailable={me.state.OPSAvailable} teacherLessonsList={me.state.teacherLessonsList[index]} gradeBox={gradeBox} productDetails={productDetails} gradeName={me.state.selectedGrade} showBillingForm={me.showBillingForm} appDetails={this.appDetails}></FlipBox>
                        )
                        }
                    ))
                    })()
                }
                </div>
            )
        }
    }

    getSampleLessons(){
        var me=this;
        if(me.state.tchrdata[me.state.currentGradeIndex].sampleLessons){
            let sampleLessons= me.state.tchrdata[me.state.currentGradeIndex].sampleLessons;
            return(
                <SampleLessonLayout sampleLessons={sampleLessons}></SampleLessonLayout>
            )
        }
    }

    getBuyOptions(){
        if(this.state.BillingFormShow && this.state.purchaseObj){
            return this.renderbillingForm()
        }
    }
    
    getProductBoxes(){
        if(this.state.currentGradeIndex >= 0 && this.state.tchrdata){
            return(
                <div className="tchrprodanim">
                 {this.getSampleLessons()}
                 {this.productCateBox()}
                 {this.getBuyOptions()}
                </div>
            )
        }
    }

    couponLayout () {

        let userLoggedIn = (this.getUser().getUserId() && this.getUser().getUserId().length > 0) ? true : false;
        let userOrigin  = this.getUser().getUserOrigin();
       
        let boxlocked = '';
        if(this.state.couponApplied){
            boxlocked = "disabled"
        }
        let couponCode = this.getAttribute("couponcodeCenta") || '';
      
            return(
                <div className={"CouponCodeBoxLayout "+boxlocked}>
                  <CouponCodeLayout {...this.props} couponCode={couponCode} couponApplied={this.state.couponApplied} showSubscriptionForm={this.props.showSubscriptionForm} setTrackId={this.setTrackId} callBackParent={this.couponValidFn} couponCodeTracked={this.state.couponCodeTracked}/>  
                </div>
                
            )
    }
  
    render(){
        var me=this;
        if(this.state.dataLoaded){
            return(
                <div className="tchrprodcomp container">
 
                 {
                     (() => {
                        
                         if(me.state.chooseGrade){
                             return(
                               <div>
                                     <div className="container">  
                                {
                                    (()=>{
                                        if(!this.state.SubscribeModal){
                                            return me.couponLayout()
                                        }
                                    })()
                                }

                                {/* {me.couponLayout()} */}

                         {me.teachergradeSwiper()}
                     
                     
                 </div> 
                             <hr/>
                                {me.getProductBoxes()}
                                {
                                    (()=>{
                                        if(this.state.SubscribeModal){
                                            return me.renderCouponCodeModel()
                                        }

                                    })()
                                }
                                   </div>
                             )
                         }
 
                         
                 })()
 
                 }

                
 
                </div>
              
         )
        }else if(this.state.noData){
            return (<div></div>);
        }else{
            return super.render();
        }
       
    }

}

export default TeacherProdComp;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/TeacherProdComp.js